import {Clock} from "@app/core/shared/domain/clock";

/**
 * Represents the user's marketing rules, handling display conditions for marketing messages.
 */
interface UserMarketingRulesPrimitives {
    downloadAppMessageClosedAt: Date | null;
}

export class UserMarketingRules {
    private constructor(
        private downloadAppModalClosedAt: Date | null = null,
    ) {}

    static fromPrimitives(primitives: UserMarketingRulesPrimitives): UserMarketingRules {
        return new UserMarketingRules(primitives.downloadAppMessageClosedAt);
    }

    static create(): UserMarketingRules {
        return new UserMarketingRules();
    }

    toPrimitives(): UserMarketingRulesPrimitives {
        return {
            downloadAppMessageClosedAt: this.downloadAppModalClosedAt,
        };
    }

    registerDownloadAppMessageViewed(clock: Clock): void {
        this.downloadAppModalClosedAt = clock.now();
    }

    shouldDisplayDownloadAppMessage(): boolean {
        const hasBeenClosed = this.downloadAppModalClosedAt != null;
        return !hasBeenClosed;
    }
}